import { connect } from 'react-redux';
import { firebase, helpers } from 'redux-react-firebase';
import Login from '../../components/auth/login';

const { pathToJS } = helpers;

const mapStateToProps = state => ({
  authError: pathToJS(state.firebase, 'authError'),
  auth: pathToJS(state.firebase, 'auth'),
});

export default firebase()(connect(mapStateToProps)(Login));



// WEBPACK FOOTER //
// ./src/containers/auth/login.js